"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var options = [
    'more_efficient_heating',
    'limit_shower_time',
    'wash_lower_temperature',
    'more_efficient_fridge_freezer',
    'reduce_water_vapour',
    'boil_kettle_as_needed',
    'wash_full_load',
    'switch_off_lights',
    'other',
];
var BehaviouralAdviceInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var adviceGiven = values.project.behavioural_advice.behavioural_advice_given;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.behavioural_advice) === null || _b === void 0 ? void 0 : _b.behavioural_advice_given, dusk: "behavioural-advice-given-field", label: trans('project:slhh::labels.behavioural-advice-given'), showOther: adviceGiven && adviceGiven.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.behavioural_advice) === null || _d === void 0 ? void 0 : _d.behavioural_advice_given_other, help: trans('project:slhh::help.client-followup-number'), label: trans('project:slhh::labels.behavioural-advice-given-other') },
                react_1.default.createElement(__1.TextArea, { fast: true, name: "project.behavioural_advice.behavioural_advice_given_other", maxLength: 5000 })) },
            react_1.default.createElement("div", { className: "flex flex-col" }, options.map(function (key) { return (react_1.default.createElement(__1.Checkbox, { key: "behavioural_advice." + key, name: "project.behavioural_advice.behavioural_advice_given", label: trans("project:slhh::enum.behavioural-advice." + key), value: key })); })))));
};
exports.default = BehaviouralAdviceInput;
//# sourceMappingURL=BehaviouralAdviceInput.js.map